var map = {
	"./apple-logo.png": 50585,
	"./exchange-logo.png": 81030,
	"./google-logo.png": 56938,
	"./live_connect-logo.png": 9660,
	"./office365-logo.png": 13457,
	"./outlook-logo.png": 1647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71584;